import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { COLOR_GREY_5 } from "shared/theme/colors";

export const StyledSecondaryTagContainer = styled(Box)`
  flex-wrap: wrap;
  border: 1px solid ${COLOR_GREY_5};
  border-radius: 8px;
  padding: 14px 16px;
`;